import { useCallback } from 'react';

import { useReactiveVar } from '@apollo/client/react';
import { workflowStepsDialogOpenVar } from 'src/components';

export function useOnClickWorkflowButton(): {
  onClickWorkflowButton: (event: React.MouseEvent) => void;
} {
  const workflowOpen = useReactiveVar(workflowStepsDialogOpenVar);
  const onClickWorkflowButton = useCallback(() => {
    workflowStepsDialogOpenVar(!workflowOpen);
  }, [workflowOpen]);

  return {
    onClickWorkflowButton,
  };
}
